import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss']
})
export class RichTextComponent implements OnInit {
  @Input()
  content = '';
  constructor() {}

  ngOnInit() {}
}
